// 画像表示
import React from 'react';
var Image = function (_a) {
    var value = _a.value;
    return (React.createElement("div", null,
        React.createElement("img", { src: value, className: "img-fluid" })));
};
export default Image;
